import { Component } from '@angular/core';

// Update the path below to match the actual location of the Header component
import { Header } from '../../core/components/header/header';
import { Footer } from '../../core/components/footer/footer';
import { SideBar } from '../../core/components/side-bar/side-bar';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  imports: [Header, Footer, SideBar, CommonModule, RouterModule],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss'
})
export class Dashboard {

}

